import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import ShuruUsersTable from './ShuruUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanyShuruUsers } from './companyShuruApi';

/**
 * Company Shuru → Employees/Members list.
 * Every user of the current population appears (those who never talked to Shuru
 * show dashes and sort last); a row opens their conversation profile.
 */
const CShuruUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanyShuruUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Shuru — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and how much they use Shuru. Open a user to
        see their conversation profile — how often and how long, never what was said.
      </p>

      <ShuruUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/shuru/user?userId=${rowData?._id}`)}
        tableName="company_shuru_users"
      />
    </div>
  );
};

export default CShuruUsers;
